/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { MainnetNotifyResponse, MainnetNotifyVars } from '../openapi-types.gen.js';

export type { MainnetNotifyResponse, MainnetNotifyVars } from '../openapi-types.gen.js';

export const useMainnetNotify = createMutationHook<MainnetNotifyVars, MainnetNotifyResponse, unknown>({
  specName: 'useMainnetNotify',
  path: '/v1/notifications/mainnet',
  method: 'POST',
  resolveUrl: (vars: MainnetNotifyVars) => `/v1/notifications/mainnet`,
  buildBody: (vars: MainnetNotifyVars) => ({ email: vars.email, locale: vars.locale, source: vars.source, consent: vars.consent }),
  parseResponse: (raw: unknown): MainnetNotifyResponse => raw as MainnetNotifyResponse,
  
  
  
});
